var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassFormItem",
    {
      attrs: {
        label: _vm.$t.__("activities.activitiesFormPanel.reminder"),
        orientation: "horizontal",
        inputSize: "none",
        size: "small"
      }
    },
    [
      _vm.displayReminderNotifInApp
        ? [
            _c("span", { staticClass: "typographies-paragraph-small-bold" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t.__("common.labels.notification")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reminder-container reminder-inapp" },
              [
                _c("CompassSwitch", {
                  staticClass: "reminder-switch",
                  attrs: {
                    value: _vm.isInAppReminderEnabled,
                    orientation: "left"
                  },
                  on: { click: _vm.handleSwitchIsInAppReminderEnabled }
                }),
                _vm._v(" "),
                _c(
                  "CompassSelect",
                  {
                    staticClass: "select-reminder",
                    attrs: {
                      value: _vm.tempInAppReminder.delay,
                      menuClass: "select-menu-reminder-activity",
                      disabled: !_vm.isInAppReminderEnabled
                    },
                    on: {
                      "update:value": function(value) {
                        return _vm.updateActivityReminder(
                          value,
                          _vm.ENUM_REMINDER_TYPES.INAPP
                        )
                      }
                    }
                  },
                  _vm._l(_vm.reminderOptions, function(reminder) {
                    return _c("CompassDropdownSelectOption", {
                      key: reminder.value,
                      attrs: { label: reminder.label, value: reminder.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "typographies-paragraph-small-bold" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.$t.__("common.labels.email")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reminder-container" },
        [
          _c("CompassSwitch", {
            staticClass: "reminder-switch",
            attrs: { value: _vm.isEmailReminderEnabled, orientation: "left" },
            on: { click: _vm.handleSwitchIsEmailReminderEnabled }
          }),
          _vm._v(" "),
          _c(
            "CompassSelect",
            {
              staticClass: "select-reminder",
              attrs: {
                value: _vm.tempEmailReminder.delay,
                menuClass: "select-menu-reminder-activity",
                disabled: !_vm.isEmailReminderEnabled
              },
              on: {
                "update:value": function(value) {
                  return _vm.updateActivityReminder(
                    value,
                    _vm.ENUM_REMINDER_TYPES.EMAIL
                  )
                }
              }
            },
            _vm._l(_vm.reminderOptions, function(reminder) {
              return _c("CompassDropdownSelectOption", {
                key: reminder.value,
                attrs: { label: reminder.label, value: reminder.value }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }